import { render } from "./ClientDetailModal.vue?vue&type=template&id=20dd55df&scoped=true"
import script from "./ClientDetailModal.vue?vue&type=script&lang=js"
export * from "./ClientDetailModal.vue?vue&type=script&lang=js"

import "./ClientDetailModal.vue?vue&type=style&index=0&id=20dd55df&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dd55df"]])

export default __exports__